module.exports = __webpack_public_path__ + "img/phone-results.ace9f16.webp";